import { MessageSquare, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";

export const RemarksTab = ({ project, onAddRemark }) => (
  <TabsContent value="remarks" className="animate-fade-in">
    <div className="bg-[#1A1A1A] border border-[#262626] rounded p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white">Remarks & Changes</h3>
        <Button onClick={onAddRemark} className="bg-[#FF4500] hover:bg-[#E65100]">
          <Plus className="w-4 h-4 mr-2" /> Add Remark
        </Button>
      </div>

      {project.remarks?.length > 0 ? (
        <div className="space-y-3">
          {project.remarks.map((remark, idx) => (
            <div key={remark.remark_id || idx} className={`p-4 bg-[#171717] rounded border border-[#262626] remark-${remark.remark_type}`}>
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`badge ${
                      remark.remark_type === 'change_request' ? 'bg-[#F59E0B]/20 text-[#F59E0B]' :
                      remark.remark_type === 'approval' ? 'bg-[#10B981]/20 text-[#10B981]' :
                      remark.remark_type === 'issue' ? 'bg-red-500/20 text-red-400' :
                      'bg-gray-700 text-gray-300'
                    }`}>
                      {remark.remark_type.replace('_', ' ')}
                    </span>
                    <span className={`badge ${remark.status === 'resolved' ? 'status-completed' : remark.status === 'pending' ? 'status-pending' : 'bg-gray-700 text-gray-300'}`}>
                      {remark.status}
                    </span>
                  </div>
                  <p className="text-white">{remark.content}</p>
                  <p className="text-xs text-gray-500 mt-2">{new Date(remark.created_at).toLocaleDateString()}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <MessageSquare className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <p className="text-gray-500">No remarks added yet</p>
        </div>
      )}
    </div>
  </TabsContent>
);
